import React, { useContext } from "react";
import "./Footer.css";
import { LanguageContext } from "../context/LanguageContext";

export default function Footer() {
  const { texts } = useContext(LanguageContext);

  return (
    <footer className="footer">
      <div className="footer-content">
        © {new Date().getFullYear()} glampingoase ·{" "}
        <a href="/impressum" className="footer-link">
          {texts.footer.impressum}
        </a>
      </div>
    </footer>
  );
}
